import React, { } from 'react'

import RequestFormDateRange from './DateRange'
import RequestFormStep2ArrivalDays from './step2ArrivalDays'
import RequestFormStayLength from './StayLength'

const RequestFormStep2 = () => {
  return (
    <>
      <div className="md:flex space-x-0 md:space-x-16 lg:space-x-32 mt-8">
        <RequestFormDateRange />

        <div className="w-full md:w-5/12 lg:w-1/2 mt-12 md:mt-0">
          <RequestFormStayLength />
          <RequestFormStep2ArrivalDays />
        </div>
      </div>
    </>
  )
}
export default RequestFormStep2
